<script setup lang="ts">
import { defineRule, Field as VeeField } from 'vee-validate'

import { maxNoteLength } from '@/utils/rulesOfValidate'

import { useBasketStore } from '@/store/basket/basket'

import BasketErrorMessage from '@/components/Basket/basket-utils/BasketErrorMessage.vue'
import BasketTitle from '@/components/Basket/basket-utils/BasketTitle.vue'

const MAX_NOTE_LENGTH_RULE = 'maxNoteLength'

const { isMobile } = useDevice()

const basketStore = useBasketStore()

const note = computed({
  get() {
    return basketStore.data.note
  },
  set(value: string) {
    basketStore.setNote(value)
  },
})

defineRule(MAX_NOTE_LENGTH_RULE, maxNoteLength)
</script>

<template>
  <section id="note">
    <vee-field
      v-slot="{ errors, field }"
      v-model="note"
      name="note"
      vid="note"
      :rules="MAX_NOTE_LENGTH_RULE"
      immediate
    >
      <basket-title title="Комментарий кухне" />

      <the-textarea
        v-bind="field"
        :model-value="note"
        class="note__item"
        counter="300"
        placeholder="Здесь можно написать пояснения или пожелания к заказу"
        :rows="isMobile ? 3 : 6"
      />

      <basket-error-message
        v-if="errors.length !== 0"
        :error-message="errors[0]"
      />
    </vee-field>
  </section>
</template>

<style lang="scss" scoped>
.note {
  &__item {
    margin-bottom: 20px;
  }
}
</style>
